import { useState, useEffect } from 'react';
import { getAPIRoot } from '../services/api';

/** Matches backend demo when API is unreachable (Hyderabad only). */
export const DEMO_HERO_SPONSOR = {
  label: 'STAGSTER Labs LLP',
  link: 'https://stagsterlabs.com',
};

/**
 * Fetches public hero sponsor line from GET /api/public/sponsor-placements?city=
 * (reads app_settings.hero_sponsor; Hyderabad falls back to demo on server and here).
 */
export function useHeroSponsor(city) {
  const [hero, setHero] = useState(null);
  const [source, setSource] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const c = (city || 'Hyderabad').trim() || 'Hyderabad';
    setLoading(true);
    (async () => {
      try {
        const API = getAPIRoot();
        const res = await fetch(`${API}/public/sponsor-placements?city=${encodeURIComponent(c)}`);
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (data?.ok && data.hero) {
          setHero(data.hero);
          setSource(data.source || null);
        } else if (c.toLowerCase() === 'hyderabad') {
          setHero(DEMO_HERO_SPONSOR);
          setSource('client-fallback');
        } else {
          setHero(null);
          setSource(null);
        }
      } catch {
        if (cancelled) return;
        if (c.toLowerCase() === 'hyderabad') {
          setHero(DEMO_HERO_SPONSOR);
          setSource('client-fallback');
        } else {
          setHero(null);
          setSource(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [city]);

  return { hero, source, loading };
}
